export const leftToRight = function (vertices: any, opt: any, linkView: joint.dia.LinkView) {
  const { sourceAnchor, targetAnchor } = linkView

  let yCoordinate: number
  const chosenYCoordinate = function (): number {
    return Math.abs(sourceAnchor.y - opt.maxY) > Math.abs(sourceAnchor.y - opt.minY)
      ? opt.minY
      : opt.maxY
  }
  if (Number.isFinite(chosenYCoordinate())) yCoordinate = chosenYCoordinate() + 20
  else yCoordinate = 0
  return [
    { x: sourceAnchor.x + 20, y: sourceAnchor.y },
    { x: sourceAnchor.x + 20, y: yCoordinate },
    { x: targetAnchor.x - 20, y: yCoordinate },
    { x: targetAnchor.x - 20, y: targetAnchor.y },
  ]
}
export const rightToLeft = function (vertices: any, opt: any, linkView: joint.dia.LinkView) {
  const { sourceAnchor, targetAnchor } = linkView

  let yCoordinate: number
  const chosenYCoordinate = function (): number {
    return Math.abs(sourceAnchor.y - opt.maxY) > Math.abs(sourceAnchor.y - (opt.minY + 20))
      ? opt.minY
      : opt.maxY
  }
  if (Number.isFinite(chosenYCoordinate())) yCoordinate = chosenYCoordinate()
  else yCoordinate = 0
  return [
    { x: sourceAnchor.x - 20, y: sourceAnchor.y },
    { x: sourceAnchor.x - 20, y: yCoordinate },
    { x: targetAnchor.x + 20, y: yCoordinate },
    { x: targetAnchor.x + 20, y: targetAnchor.y },
  ]
}
